/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Iconik_Publish_Failed_ErrorInputs */



/**
* | output |
* | --- |
* | "Publish Failed. {message}" |
*
* @param {Iconik_Publish_Failed_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_failed_error = /** @type {((inputs: Iconik_Publish_Failed_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Failed_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de publication. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Veröffentlichung fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Pubblicazione non riuscita. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Публикация не удалась. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Publicación fallida. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`发布失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`公開に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रकाशन विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Publicação falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Publish Failed. ${i?.message}`)
});